import Cookie from 'js-cookie'
export default {
    state: {
        token: '',
        refreshToken: '',
        userMenu: [],
        userInfo: {}
    },
    mutations: {
        setToken(state, tokenObj) {
            state.token = tokenObj.token;
            state.refreshToken = tokenObj.refreshToken;
            Cookie.set('user-token', tokenObj.token);
            Cookie.set('user-refreshToken', tokenObj.refreshToken)
        },
        clearToken(state) {
            state.token = "";
            state.refreshToken = "";
            Cookie.remove('user-token');
            Cookie.remove('user-refreshToken');
        },
        getToken(state) {
            state.token = Cookie.get('user-token') || state.token;
            state.refreshToken = Cookie.get('user-refreshToken') || state.refreshToken;
        },
        setUserMenu(state, userMenu) {
            state.userMenu = userMenu;
            localStorage.setItem("userMenu", JSON.stringify(userMenu));
        },
        getUserMenu(state) {
            state.userMenu = JSON.parse(localStorage.getItem("userMenu"));
        },
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
            localStorage.setItem("userInfo", JSON.stringify(userInfo));
        },
        getUserInfo(state) {
            state.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        },
    }
}